import React from 'react';
import useRoute from '@/Hooks/useRoute';
import IconFork from '@/svgs/code-fork.svg?react';
import useForceUrlDomain from '@/Hooks/useForceUrl';

interface Props {
  file: App.Data.FileData;
}

export default function ForkButton({ file }: Props) {
  const route = useRoute();

  let url = route('files.fork', { file: file.id });
  url = useForceUrlDomain(url, 'app');

  return (
    <a href={url} className="flex items-center whitespace-nowrap">
      <IconFork className="mr-1" />
      Fork This
    </a>
  );
}
